"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RetryScheduleInOut = void 0;
class RetryScheduleInOut {
    constructor() {
    }
    static getAttributeTypeMap() {
        return RetryScheduleInOut.attributeTypeMap;
    }
}
exports.RetryScheduleInOut = RetryScheduleInOut;
RetryScheduleInOut.discriminator = undefined;
RetryScheduleInOut.attributeTypeMap = [
    {
        "name": "retrySchedule",
        "baseName": "retrySchedule",
        "type": "Array<Duration>",
        "format": ""
    }
];
//# sourceMappingURL=RetryScheduleInOut.js.map